var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vi-iconClip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 43
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "vi-bgGrad",
    cx: "40%",
    cy: "35%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c2fd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#4a0090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e003a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vi-cyanGlow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "vi-pinkGlow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "vi-yellowGlow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "vi-softGlow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vi-bar1Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff006b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff4488",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vi-bar2Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00d9ff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vi-bar3Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#39ff14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#39ff14",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vi-bodyGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a0a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#150030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vi-topGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3a1060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a0540"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vi-barClip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 79,
    width: 64,
    height: 10,
    rx: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vi-barClip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 95,
    width: 64,
    height: 10,
    rx: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vi-barClip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 111,
    width: 64,
    height: 10,
    rx: 5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vi-iconClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 22,
    fill: "url(#vi-bgGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 25,
    r: 1.2,
    fill: "#ff006b",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0.1;0.6",
    dur: "2.1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 30,
    r: 1,
    fill: "#00d9ff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0.1;0.5",
    dur: "1.7s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 170,
    r: 1.5,
    fill: "#39ff14",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;0.1;0.4",
    dur: "2.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 165,
    r: 1.2,
    fill: "#ff006b",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0.15;0.5",
    dur: "1.9s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 12,
    r: 1,
    fill: "#00d9ff",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;0.1;0.4",
    dur: "3.1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vi-yellowGlow)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "28,38 22,62 30,60 24,82 38,54 29,57",
    fill: "#ffcc00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.85;0.3;0.85",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vi-yellowGlow)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "172,38 178,62 170,60 176,82 162,54 171,57",
    fill: "#ffcc00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.85;0.3;0.85",
    dur: "1.8s",
    begin: "0.9s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vi-cyanGlow)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "42,18 38,32 44,30 40,44 50,26 43,29",
    fill: "#00d9ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;0.2;0.7",
    dur: "2.3s",
    begin: "0.4s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vi-cyanGlow)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "158,18 162,32 156,30 160,44 150,26 157,29",
    fill: "#00d9ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;0.2;0.7",
    dur: "2.3s",
    begin: "1.2s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vi-softGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 45,
    width: 90,
    height: 105,
    rx: 18,
    fill: "url(#vi-bodyGrad)",
    stroke: "#7c3aed",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#7c3aed;#ff006b;#00d9ff;#7c3aed",
    dur: "3s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 45,
    width: 90,
    height: 105,
    rx: 18,
    fill: "none",
    stroke: "#a855f7",
    strokeWidth: 0.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 45,
    rx: 35,
    ry: 12,
    fill: "url(#vi-topGrad)",
    stroke: "#a855f7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 43,
    rx: 22,
    ry: 5,
    fill: "none",
    stroke: "#c084fc",
    strokeWidth: 0.8,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 33,
    width: 18,
    height: 12,
    rx: 4,
    fill: "#1a0840",
    stroke: "#7c3aed",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 39,
    r: 4,
    fill: "#0a0020",
    stroke: "#a855f7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 39,
    r: 1.5,
    fill: "#00d9ff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0.2;0.8",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 72,
    width: 10,
    height: 30,
    rx: 5,
    fill: "#1a0840",
    stroke: "#7c3aed",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 72,
    width: 10,
    height: 30,
    rx: 5,
    fill: "#1a0840",
    stroke: "#7c3aed",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 80,
    r: 2.5,
    fill: "#ff006b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#ff006b;#ff4400;#ff006b",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 95,
    r: 2.5,
    fill: "#00d9ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00d9ff;#0044ff;#00d9ff",
    dur: "1.4s",
    begin: "0.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 80,
    r: 2.5,
    fill: "#39ff14"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#39ff14;#00ff44;#39ff14",
    dur: "1.3s",
    begin: "0.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 95,
    r: 2.5,
    fill: "#ffcc00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#ffcc00;#ff8800;#ffcc00",
    dur: "1.6s",
    begin: "0.9s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 79,
    width: 64,
    height: 10,
    rx: 5,
    fill: "#1a0840",
    stroke: "#ff006b",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 79,
    width: 64,
    height: 10,
    rx: 5,
    fill: "url(#vi-bar1Grad)",
    clipPath: "url(#vi-barClip1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "40;64;50;64;45;64",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 73,
    y: 87,
    fontFamily: "Arial, sans-serif",
    fontSize: 5.5,
    fontWeight: "bold",
    fill: "#fff"
  }, "SONG A"), /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 87,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fontWeight: "bold",
    fill: "#ff006b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#ff006b;#fff;#ff006b",
    dur: "2.5s",
    repeatCount: "indefinite"
  }), "\u26A142\n  "), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 95,
    width: 64,
    height: 10,
    rx: 5,
    fill: "#1a0840",
    stroke: "#00d9ff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 95,
    width: 64,
    height: 10,
    rx: 5,
    fill: "url(#vi-bar2Grad)",
    clipPath: "url(#vi-barClip2)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "50;38;55;42;50;38",
    dur: "3.1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 73,
    y: 103,
    fontFamily: "Arial, sans-serif",
    fontSize: 5.5,
    fontWeight: "bold",
    fill: "#fff"
  }, "SONG B"), /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 103,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fontWeight: "bold",
    fill: "#00d9ff"
  }, "\u26A131"), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 111,
    width: 64,
    height: 10,
    rx: 5,
    fill: "#1a0840",
    stroke: "#39ff14",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 111,
    width: 64,
    height: 10,
    rx: 5,
    fill: "url(#vi-bar3Grad)",
    clipPath: "url(#vi-barClip3)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "30;45;28;40;30;45",
    dur: "2.8s",
    begin: "0.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 73,
    y: 119,
    fontFamily: "Arial, sans-serif",
    fontSize: 5.5,
    fontWeight: "bold",
    fill: "#fff"
  }, "SONG C"), /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 119,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fontWeight: "bold",
    fill: "#39ff14"
  }, "\u26A118"), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 130,
    width: 84,
    height: 17,
    rx: 8,
    fill: "#0d0025",
    stroke: "#7c3aed",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 138.5,
    r: 5,
    fill: "#0a0020",
    stroke: "#a855f7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 138.5,
    r: 2.5,
    fill: "#ff006b",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.5;3.5;2.5",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;1;0.6",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 138.5,
    r: 5,
    fill: "#0a0020",
    stroke: "#a855f7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 138.5,
    r: 2.5,
    fill: "#00d9ff",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.5;3.5;2.5",
    dur: "1s",
    begin: "0.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;1;0.6",
    dur: "1s",
    begin: "0.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 133,
    x2: 90,
    y2: 144,
    stroke: "#7c3aed",
    strokeWidth: 0.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 133,
    x2: 96,
    y2: 144,
    stroke: "#7c3aed",
    strokeWidth: 0.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 133,
    x2: 102,
    y2: 144,
    stroke: "#7c3aed",
    strokeWidth: 0.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: 133,
    x2: 108,
    y2: 144,
    stroke: "#7c3aed",
    strokeWidth: 0.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 150,
    rx: 30,
    ry: 5,
    fill: "#1a0840",
    stroke: "#7c3aed",
    strokeWidth: 0.5,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 150,
    r: 2,
    fill: "#ffcc00",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.9;0.3;0.9",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff006b",
    filter: "url(#vi-pinkGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 140,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 128,
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 128,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "2s",
    repeatCount: "indefinite",
    attributeType: "XML"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#00d9ff",
    filter: "url(#vi-cyanGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 140,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 128,
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 128,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "2s",
    begin: "1s",
    repeatCount: "indefinite",
    attributeType: "XML"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 172,
    textAnchor: "middle",
    fontFamily: "Arial Black, sans-serif",
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#00d9ff",
    filter: "url(#vi-cyanGlow)"
  }, "VOTE FOR A "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#ff006b",
    filter: "url(#vi-pinkGlow)"
  }, "SONG")), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 175,
    x2: 145,
    y2: 175,
    stroke: "#7c3aed",
    strokeWidth: 0.8,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#7c3aed;#ff006b;#00d9ff;#7c3aed",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffcc00"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "18,105 19.5,108 23,108 20.5,110 21.5,114 18,112 15,114 16,110 13.5,108 17,108"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "182,105 183.5,108 187,108 184.5,110 185.5,114 182,112 179,114 180,110 177.5,108 181,108"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2.2s",
    begin: "1.1s",
    repeatCount: "indefinite"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 1.6,
    width: 196.9,
    height: 196.9,
    rx: 43,
    fill: "none",
    stroke: "white",
    strokeWidth: 5.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteIcon);
export default __webpack_public_path__ + "static/media/vote-icon.2d9411b4959bb440fe081a0e5b136a90.svg";
export { ForwardRef as ReactComponent };